export const pricing = [
  {
    title: "Cours à l'unité",
    price: "80 €",
    unit: "/ heure",
    description: "Individuel ou en couple. Idéal pour découvrir.",
    cta: "Réserver",
    highlight: false,
  },
  {
    title: "Pack 5 heures",
    price: "370 €",
    unit: "5 cours",
    description: "Le bon compromis pour progresser sereinement.",
    cta: "Choisir ce pack",
    highlight: true,
  },
  {
    title: "Pack 10 heures",
    price: "720 €",
    unit: "10 cours",
    description: "Pour préparer un mariage ou viser l'aisance complète.",
    cta: "Choisir ce pack",
    highlight: false,
  },
];

export const pricingNote = "Les tarifs peuvent être adaptés selon le format du cours, le lieu, le nombre de personnes et le projet, notamment pour les mariages ou les cours collectifs. Déplacement : +10 € selon localisation.";
